import React, { useState, useEffect ,useMemo} from "react";
import BreadCrumb from "../../BreadCrumb";
import Layout from "../../Layout";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import PageLoader from "../../../common/Loader";
import DataTable from "../../Tables/DataTable";
import SweetAlert from 'react-bootstrap-sweetalert';
import InfiniteScroll from "react-infinite-scroll-component";
import { default as ReactSelect } from "react-select";
import {
  getStudentsListAction,
  fetchClassRoomsAction,
  assingClassRoomAction,
  sendMessageAction,
  deleteStudentAction,
  resetStudentListAction,
  downloadListAction,
  dueAmountAction,
  resetDueAmountAction,
  updatePerPageAction,
  formatStudentsList,
  SET_STUDENTS_LIST
} from "../../../redux/actions/studentActions";
import Filters from "../Filter";
import AssingClass from "./assignClass";
import AdmissionForward from "./admissionForward";
import PayForDress from "./payForDress";
import SendNotification from "./sendNotification";
import { getReqValue } from "../../../common/constants";
import DynamicFilters from "../../DynamicFilters";
import { Button,Badge } from "react-bootstrap";
import AgGridTable from "../../Tables/agGridTable";
import callApi from "../../../Api";

const StudentList = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loader, studentProfiles,dueAmount , pagination } = useSelector((state) => state.student);
  console.log(pagination,studentProfiles,pagination)
  const [selectedStudentEvent, setSelectedStudentEvent] = useState({});
  const [sideMenu, setSideMenu] = useState(true);
  const [show, setShow] = useState(false);
  const [admissionFwdShow, setAdmissionFwdShow] = useState(false);
  const [payForDressShow, setPayForDressShow] = useState(false);
  const [sendNotificationShow, setSendNotificationShow] = useState(false);
  const [filterLoader, setFilterLoader] = useState(false);
  const [branch, setBranch] = useState([]);
  const [classGroup, setClassGroup] = useState([]);
  const [classRoom, setClassRoom] = useState([]);
  const [year, setYear] = useState([]);
  const [searchByName, setSearchByName] = useState(null);
  const [regNo, setRegNo] = useState(null);
  const [deleteShow, setDeleteShow] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const [perPage, setPerPage] = useState({value:20,label:20})
  const [agGridRef, setAgGridRef] = useState(null);
  const [rowNode, setRowNode] = useState(null);

  
  useEffect(() => {
    dispatch(resetStudentListAction())
  }, [])
  
  const onSideMenu = (value) => {
    setSideMenu(value);
  };

  const notifyAction = async (data) => {
    if(data.isActive){
      setSelectedStudentEvent(data);
      setSendNotificationShow(true);
    }
    
  };
  const admisssionForwardAction = async (data) => {
    if(data.isActive){
      await dispatch(dueAmountAction({
        StudentFeeId: data.StudentFeeId
      }))
      setSelectedStudentEvent(data);
      // history.push(`studentsList/admissionForward/${data.StudentId}`);
      setDeleteShow(true)
    }
  };
  const handleAdmisssionForward = async (data) => {
    console.log(selectedStudentEvent)
    console.log("Adminssion Forward",dueAmount)
    if(dueAmount > 0){
      history.push(`paymentDue/student/${selectedStudentEvent.StudentFeeId}`);
    }else{
      history.push(`studentsList/admissionForward/${selectedStudentEvent.StudentId}`);
    }
      // history.push(`studentsList/admissionForward/${selectedStudentEvent.StudentId}`);
  };
  
  const editAction = async (data) => {
    // if(data.isActive){
      history.push(`/studentsList/details/${data.StudentId}`);
    // }
  };
  const payForDressAction = async (data) => {
    if(data.isActive){
      data.taxBenfits = data.Student.taxBenfits;
      setSelectedStudentEvent(data);
      setPayForDressShow(!payForDressShow);
    }
    
  };
  const assignClass = async (data,rowNodeRef) => {
    if(data.isActive){
      await dispatch(
        fetchClassRoomsAction({
          BranchClassGroupId: data.BranchClassGroupId,
        })
      );
      setRowNode(rowNodeRef)
       // const rowNode = props.agGridTableData.current.api.getRowNode(String(props.data.id));
                // rowNode.setData({...rowNode.data,isAssignClassPending:false});
      setSelectedStudentEvent(data);
      setShow(!show);
    }
    
  };
  const deleteAction = async (data) => {
    if(data.isActive){
      setSelectedStudentEvent(data);
     setDeleteShow(true)
    }
    
  };
  const headerList = [
    {
      name: "Enrollment No",
      key: "RegNo",
    },
    {
      name: "Name",
      key: "name",
    },
    {
      name: "Email",
      key: "email",
    },

    {
      name: "Guardians",
      key: "Guardians",
      requiredActions: [
        {
          name: "Father",
          dataKey: "father_name",
        },
        {
          name: "Father",
          dataKey: "father_phone",
        },
        {
          name: "Mother",
          dataKey: "mother_name",
        },
        {
          name: "Mother",
          dataKey: "mother_phone",
        },
      ],
    },
    { name: "Class Group", key: "ClassGroupName" },
    { name: "Class", key: "classRoomName" },
    { name: "Application Date", key: "dateOfAssign" },
    {
      name: "Action",
      key: "action",
      requiredActions: [
        {
          actionKey: "Notify Student",
          icon: "fa fa-bell",
          handleAction: notifyAction,
        },
        {
          actionKey: "Pay for other than course fee",
          icon: "fa fa-money",
          handleAction: payForDressAction,
        },
        {
          actionKey: "Edit Student",
          icon: "fa fa-edit",
          handleAction: editAction,
        },
        {
          actionKey: "Admission Forward",
          icon: "fa fa-sign-out",
          handleAction: admisssionForwardAction,
        },
        {
          actionKey: "Assign Class",
          icon: "fa fa-plus-circle",
          handleAction: assignClass,
        },
      ],
    },
  ];
  const actionsListComponent = props => {
    console.log(props)
    return (
      <>
          {
            props.data ? (
              <>
              <span>
            <i class={"fa fa-bell" + (props.data.isPreviousHistory ?  ' fa-disabled': ''  )}  aria-hidden="true" title="Notify Student" style={{
          alignItems: "center",
          color: "#1c5983",
          cursor: 'pointer',
          fontSize:"18px"
          
        }} onClick={()=>{
          props.notifyAction(props.data);
        }}></i> &nbsp;&nbsp;&nbsp;
         <i class={"fa fa-money" + (props.data.isPreviousHistory ?  ' fa-disabled': ''  ) } aria-hidden="true" title="Pay For" style={{
          alignItems: "center",
          cursor: 'pointer',
          color: "#1c5983",
          fontSize:"18px"
        }} onClick={()=>{
          props.payForDressAction(props.data);
        }} ></i>&nbsp;&nbsp;&nbsp;
        <i class={"fa fa-edit" + (props.data.isPreviousHistory ?  '': ''  ) } aria-hidden="true" title="Edit Student" style={{
          alignItems: "center",
          color: "#1c5983",
          cursor: 'pointer',
          fontSize:"18px"
          
        }}  onClick={()=>{
          props.editAction(props.data);
        }}></i> &nbsp;&nbsp;&nbsp;
         
          {
            props.data.isAssignClassPending ? (
              <>
              <i class="fa fa-plus-circle" aria-hidden="true" title="Assign Class" style={{
                alignItems: "center",
                cursor: 'pointer',
                fontSize:"18px",
                color: "#1c5983",
                
              }} onClick={()=>{
                const rowNodeObj = props.agGridRef.current.api.getRowNode(String(props.data.id));
                props.assignClass(props.data,rowNodeObj);
                // rowNode.setData({...rowNode.data,isAssignClassPending:false});
              }} ></i>
              </>
            ) : (
              <>
              <i class={"fa fa-sign-out" + (props.data.isPreviousHistory ?  ' fa-disabled': ''  ) } aria-hidden="true" title="Admission Forward" style={{
          alignItems: "center",
          cursor: 'pointer',
          fontSize:"18px",
          color: "#1c5983",
          
        }} onClick={()=>{
          props.admisssionForwardAction(props.data);
        }} ></i>
              </>
            ) 
          }
          </span>
              </>
            ): null 

          }
          
         
        
      </>
    )  
  };
  const columnDefs = [
    {
      headerName: "Reg No",
      field: "RegNo",
      filter:true,floatingFilter:true,sortable: true,
      // cellClass:"vertical-middle",
    },
    {
      headerName: "Name",
      field: "name",
      filter:true,floatingFilter:true,sortable: true,
      // cellClass:"vertical-middle",
    },
    {
      headerName: "Email",
      field: "email",
      filter:true,floatingFilter:true,sortable: true,
      // cellClass:"vertical-middle",
    },
    // {
    //   headerName: "Mother Name",
    //   field: "mother_name",
    //   // filter:true,floatingFilter:true,sortable: true,
    //   // cellClass:"vertical-middle",
    // },
    {
      headerName: "Mother Phone Number",
      field: "phoneNumber",
      filter:true,floatingFilter:true,sortable: true,
      // filter:true,floatingFilter:true,sortable: true,
      // cellClass:"vertical-middle",
    },
    {
      headerName: "Father Phone Number",
      field: "father_phone",
      // filter:true,floatingFilter:true,sortable: true,
      // cellClass:"vertical-middle",
    },
    
    { headerName: "Class Group", field: "ClassGroupName",
    maxWidth:150,
    // sortable: true,
    // cellClass:"vertical-middle", 
  },
    { headerName: "Class", field: "classRoomName" ,
    // cellClass:"vertical-middle",
  },
  //   { headerName: "Application Date", field: "dateOfAssign" ,
  //     // cellClass:"vertical-middle", 
  // },
    {
      headerName: "Action",
      field: "action",
      maxWidth: 150,
      // cellClass:"vertical-middle",
      cellRenderer: "actionsListComponent",
      cellRendererParams: {
        notifyAction,
        payForDressAction,
        editAction,
        admisssionForwardAction,
        assignClass,
        agGridRef
      },
      
    },
  ];

  const nestedHeaders = [
    "",
    "",
    "",
    "Name",
    "Phone Number ",
    "Name",
    "Phone Number",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
  ];
  const closeModal = () => {
    setShow(false);
    // setPayForDressShow(false);
    // setSendNotificationShow(false);
  };
  const closePaydressModal = () => {
    setPayForDressShow(false);
    // setSendNotificationShow(false);
  };
  const closeNotificationModal = () => {
    setSendNotificationShow(false);
  };
  const assingClassRoom = async (data) => {
    const reqParams = {
      ...data,
      StudentId: selectedStudentEvent.StudentId,
    };
    await dispatch(assingClassRoomAction(reqParams, [...studentProfiles]));
    let updateObj = { ...rowNode.data}
        updateObj.classRoomName = reqParams.classRoomName
        updateObj.ClassRoom = {name: reqParams.classRoomName}
        updateObj.ClassRoomId = reqParams.ClassRoomId
        updateObj.isAssignClassPending = false;
    rowNode.setData({...updateObj});
  };
  const sendMessage = async (data) => {
    const reqParams = {
      ...data,
      StudentId: selectedStudentEvent.StudentId,
      BranchId: selectedStudentEvent.BranchId,
      ClassGroupId: selectedStudentEvent.ClassGroupId,
      ClassRoomId: selectedStudentEvent.ClassRoomId,
    };
    await dispatch(sendMessageAction(reqParams));
  };
  const DynamicFiltersProps = [
    {
      type: "Select",
      placeholder: "Select Year",
      state: year,
      mappingKey: "year",
      // onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
      label: "Year",
    },
    {
      type: "Select",
      placeholder: "Select Branch",
      state: branch,
      mappingKey: "branch",
      onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
      label: "Branch",
    },
    {
      type: "Select",
      placeholder: "Select ClassGroup",
      state: classGroup,
      mappingKey: "classGroup",
      onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
      label: "Class Group",
    },
    {
      type: "Select",
      placeholder: "Select ClassRoom",
      state: classRoom,
      mappingKey: "classRoom",
      // onMenuCloseApi: true,
      grid: "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
      label: "ClassRoom",
    },
    // {
    //   type: "TextField",
    //   placeholder: "Select By RegNo",
    //   state: regNo,
    //   mappingKey: "regNo",
    //   // onMenuCloseApi: true,
    //   grid: "col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2",
    //   label: "Reg No",
    // },
    // {
    //   type: "TextField",
    //   placeholder: "Select By Email Or Name",
    //   state: searchByName,
    //   mappingKey: "searchByName",
    //   // onMenuCloseApi: true,
    //   grid: "col-xs-12 col-sm-6 col-md-2 col-lg-2 col-xl-2",
    //   label: "Email /Name",
    // },
    
  ];

  const DynamicFiltersOptions = {
    branchOptions: [],
    classGroupOptions: [],
    classRoomOptions: [],
    yearOptions: [],
  };

  const hierarchyLevel = ["branch", "classGroup", "classRoom"];
  const hierarchyApiCalls = [
    {
      optionsMappingKey: "branch",
      UrlName: "branch",
    },
    {
      optionsMappingKey: "year",
      UrlName: "year",
    },
  ];
  const hierarchyFilterApi = "branchFilter";
  const onRefresh = () => {
    reloadData();
  };
  const reloadData = () => {
    setBranch([]);
    setClassGroup([]);
    setClassRoom([]);
    setYear([]);
    setSearchByName(null);
    setRegNo(null)
    dispatch(resetStudentListAction())
  };
  const updateState = (params) => {
    let keysLength = Object.keys(params).length;
    if (params.hasOwnProperty("branch")) {
      setBranch(params[`branch`]);
    }
    if (params.hasOwnProperty("classGroup")) {
      setClassGroup(params[`classGroup`]);
    }
    if (params.hasOwnProperty("classRoom")) {
      setClassRoom(params[`classRoom`]);
    }
    if (params.hasOwnProperty("year")) {
      setYear(params[`year`]);
    }
    if (params.hasOwnProperty("searchByName")) {
      setSearchByName(params[`searchByName`]);
    }
    if (params.hasOwnProperty("regNo")) {
      setRegNo(params[`regNo`]);
    }
    
  };
  const fetchParamsList = async()=>{
    const params = {
      BranchId: getReqValue(branch),
      ClassGroupId: getReqValue(classGroup),
      ClassRoomId: getReqValue(classRoom),
      year: getReqValue(year),
      searchByName,
      RegNo:regNo,
      // page:( pagination.currentPage + 1),
      perPage: pagination.perPage
    };
    return params;
  }
  const fetchStudentsList = async(params)=>{
    console.log(pagination)
    
    await dispatch(getStudentsListAction(params));
  }
  const filterData = async () => {
    await dispatch(resetStudentListAction())
    let reqParams = await fetchParamsList();
    reqParams.page = 1;
    await fetchStudentsList(reqParams);
    setHasMore(true)
  };

  
  const openLoader = () => {
    setFilterLoader(true);
  };
  const closeLoader = () => {
    setFilterLoader(false);
  };
  const notifyStudent =async()=>{
    await dispatch(deleteStudentAction({
      StudentId: selectedStudentEvent.StudentId,
    },studentProfiles))
    setDeleteShow(false);
  }
  const onCancel = ()=>{
    setDeleteShow(false);
     dispatch(resetDueAmountAction())
  }
  const downloadPaymentReports = async() => {
    const params = {
      BranchId: getReqValue(branch),
      ClassGroupId: getReqValue(classGroup),
      ClassRoomId: getReqValue(classRoom),
      year: getReqValue(year),
      searchByName,
      RegNo:regNo
    };
    await dispatch(downloadListAction(params));

  }
  const fetchMoreData =async()=>{
    // if (studentProfiles.length === pagination.totalItems) {
    
    if ((pagination.totalPages === 1 || (pagination.totalPages -1) === pagination.currentPage)  ) {
      setHasMore(false)
      return;
    }
    let reqParams = await fetchParamsList();
    reqParams.page = ( pagination.currentPage + 1);
    await fetchStudentsList(reqParams);
    
  }
  const handlePageSelection =(params)=>{
    setPerPage(params);
    dispatch(updatePerPageAction({
      perPage: params.value
    }))
  }
  // const datasource = {
  //   getRows: async (params)=> {
  //     console.log(JSON.stringify(params, null, 1));
  //     const { startRow, endRow, filterModel, sortModel } = params;
  //   if(pagination.currentPage ===1 && startRow === 0 ){
  //     params.successCallback(studentProfiles, pagination.totalItems);
  //   }else{
  //     let reqParams = await fetchParamsList();
  //     const data = await callApi.get(`student/list?page=${endRow/pagination.perPage}`,{params:reqParams});
  //     const rows = formatStudentsList(data.data.data.rows)
  //     params.successCallback(rows,data.data.data.totalItems)
  //   }
        
  //   }
  // };
const setGridRefData =(params)=>{
  setAgGridRef(params)
}
 
  return (
    <div className="page-wrapper">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader || filterLoader}>
        <div
          className={`main-content d-flex flex-column ${
            sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
          <div class="row filter-block">
            <DynamicFilters
              filtersList={DynamicFiltersProps}
              options={DynamicFiltersOptions}
              hierarchyLevel={hierarchyLevel}
              hierarchyApiCalls={hierarchyApiCalls}
              hierarchyFilterApi={hierarchyFilterApi}
              openLoader={openLoader}
              closeLoader={closeLoader}
              updateParentState={updateState}
              filterData={filterData}
              onReset={onRefresh}
              viewType="verticle"
              isFilterButtonDisabled={branch.length === 0 || year.length === 0}
            />
          </div>
          <div className="spacer"> </div>
          {deleteShow ? (
               <SweetAlert
               warning="warning"
               showCancel
               confirmBtnText="Continue"
               confirmBtnBsStyle="info"
               title="Are you sure?"
               onConfirm={handleAdmisssionForward}
               onCancel={onCancel}
               focusCancelBtn
             >
               {dueAmount > 0 ? `Student has to Pay ${dueAmount}` : null }
             </SweetAlert>
   
          ): null }
          {show ? (
            <AssingClass
              show={show}
              closeModal={closeModal}
              assingClassRoom={assingClassRoom}
              data={selectedStudentEvent}
            />
          ) : null}
          {admissionFwdShow ? (
            <AdmissionForward
              show={admissionFwdShow}
              closeModal={closeModal}
              data={selectedStudentEvent}
            />
          ) : null}
          {payForDressShow ? (
            <PayForDress
              payForDressShow={payForDressShow}
              setPayForDressShow={setPayForDressShow}
              closeModal={closePaydressModal}
              data={selectedStudentEvent}
            />
          ) : null}
          {sendNotificationShow ? (
            <SendNotification
              show={sendNotificationShow}
              closeModal={closeNotificationModal}
              sendMessage={sendMessage}
              data={selectedStudentEvent}
            />
          ) : null}
          <div className="row">
                <div className="col-2">
                  <Button
                      className="btn  app-default-button btn-sm"
                    >
                      Total Students <Badge variant="primary">{pagination.totalItems}</Badge>
                    </Button>
                    
                  </div>
                  <div className="col-2">
                    {/* <ReactSelect
                      placeholderButtonLabel={"Select Per Page list"}
                      options={[{
                        value:20,label:20},{
                        value:50,label:50},{
                        value:100,label:100},{
                        value:150,label:150}
                      ]}
                      value={perPage}
                      disabled={studentProfiles.length === 0}
                      onChange={handlePageSelection}
                    /> */}
                  </div>
                  <div className="col-6"></div>
                <div className="col-2 col-offset-4 text-right">
                <Button
                      className="btn  app-default-button btn-sm"
                      disabled={studentProfiles.length === 0}
                      onClick={downloadPaymentReports}
                    >
                      <i className="fa fa-download"></i>
                    </Button>
                  </div>
            </div>
            <div className="spacer"></div>
          {studentProfiles.length > 0 ? (
            <>
            {/* <InfiniteScroll
              dataLength={studentProfiles.length}
              next={fetchMoreData}
              hasMore={pagination.totalPages === 1 ? false : hasMore}
              loader={<h4>Loading...</h4>}
              endMessage={
                <div className="alert alert-success text-center">
                  Yay! You have seen it all
                </div>
              }
            > */}
            {/* <DataTable
              header={headerList}
              data={studentProfiles}
              nestedHeader={nestedHeaders}
            /> */}
            <AgGridTable 
            rowData={studentProfiles} 
            columnDefs={columnDefs} 
            defaultColDef={{
              resizable: true,minWidth: 100}}
            frameworkComponents={{
                actionsListComponent
            }}
            pagination={pagination}
            // datasource={datasource}
            isPaginationRequired={true}
            actionType={SET_STUDENTS_LIST}
            fetchParamsList={fetchParamsList}
            setAgGridRef={setGridRefData}
              />
            {/* </InfiniteScroll> */}
            </>
          ) : (
            <div className="alert alert-success">No Data to view</div>
          )}
        </div>
      </PageLoader>
    </div>
  );
};

export default StudentList;
